import React from 'react';

const ContactPage = () => (
  <>
    <div className="bg-dark py-5 px-md-5 d-flex flex-wrap align-items-center justify-content-between justify-content-xs-center justify-content-md-center justify-content-sm-center">
      <div className="d-flex mx-5 flex-column gap-4 align-items-start justify-content-center" style={{ maxWidth: '500px' }}>
        <h2 className="text-white fw-bold display-3 fs-1">
          Your Solution for Reliable Medical Supply!
        </h2>
        <p className="text-white fs-5">
          Elevate your health journey with exclusive discounts and unparalleled convenience. 
          Your path to well-being starts here, where every purchase is a prescription for savings.
        </p>
      </div>
      <div className="bg-dark d-flex flex-column gap-3 align-items-center justify-content-center shadow w-10 mx-4 p-4" style={{ width: '605px' }}>
        <h2 className="text-white text-center fw-bold display-5 fs-3">
          Contact Us!
        </h2>
        <form className="bg-dark text-white d-flex flex-column fs-5 w-100 px-0 pb-1 px-lg-5 pb-lg-5">
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Name
            </label>
            <input txype="text" className="form-control" id="namex" placeholder="" />
          </div>
          <div className="mb-3">
            <label htmlFor="email" className="form-label">
              Email
            </label>
            <input type="email" className="form-control" id="email" placeholder="" />
          </div>
          <div className="mb-3">
            <label htmlFor="content" className="form-label">
              Content
            </label>
            <textarea className="form-control" id="content" rows="3" placeholder=""></textarea>
          </div>
          <button type="submit" className="btn btn-outline-dark bg-primary btn-lg fw-bold">
            Send
          </button>
        </form>
      </div>
    </div>
  </>
);

export default ContactPage;